import React from "react";

import DataFetcher from "./components/DataFetcher/DataFetcher";


function App() {
  return (
    <div className="App">
      <DataFetcher />

    </div>
  );
}

export default App;
